// a constant named RBIPaymentError exists in the payments package as well
export const RBIPaymentError = {
  TOKENIZATION_FAILURE: 'tokenization failure',
};

// these are duplicates of constants in packages/payments/src/constants.ts used in the backend
export const LOG_MESSAGE_ADD_CREDIT_ACCOUNT_SUCCESS = 'Add Credit Account Success';
export const LOG_MESSAGE_ADD_CREDIT_ACCOUNT_ATTEMPT = 'Add Credit Account Attempt';
export const LOG_MESSAGE_ADD_CREDIT_ACCOUNT_FAILED = 'Add Credit Account Failure';
